// The UX flows a school can be switched to (Klanten > "UX flow"). Hardcoded on purpose:
// a flow only exists when there is code for it. `route` is where the users of that school
// land after logging in; the standard flow has no route and uses the regular portal.
export const DEFAULT_UX_FLOW = 'standard';

export const UX_FLOW_OPTIONS = [
  { value: 'standard', label: 'Standaard', route: '' },
  { value: 'bso-beta', label: 'BSO Beta UX flow', route: '/flow/bso' }
];

export function getUxFlowRoute(uxFlow) {
  return UX_FLOW_OPTIONS.find((flow) => flow.value === uxFlow)?.route || '';
}
